// extracted by mini-css-extract-plugin
module.exports = {"discount-price":"F8k2YvdbKkQd9UX4r1-uw"};